import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "io-input-wrapper" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["innerHTML"]

import getRandomId from '@/utils/getRandomId.ts';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputWrapper',
  props: {
    label: { default: undefined }
  },
  setup(__props: any) {



const inputId = getRandomId('io-');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _unref(inputId)
        }, [
          _renderSlot(_ctx.$slots, "inLabel", { inputId: _unref(inputId) }),
          _createElementVNode("span", { innerHTML: _ctx.label }, null, 8, _hoisted_3)
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", { inputId: _unref(inputId) })
  ]))
}
}

})